import {
  CircularProgress,
  Search,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";
import type { TFunction } from "i18next";
import type { Control } from "react-hook-form";

import { ControlledTextField } from "@/components/shared/ControlledTextField/component";

import {
  StyledAccountContainer,
  StyledInputContainer,
  StyledSearchButton,
  StyledSection,
  StyledSelectedAccountTextContainer,
} from "../styles";
import type { GetCreationTemplateFormType } from "../types";

type SelectedAccount = {
  number?: string;
  accountId?: string;
  name?: string;
  label?: string;
};

type AccountSearchProps = {
  control: Control<GetCreationTemplateFormType>;
  tFormData: TFunction<"formData">;
  isAccountLoading: boolean;
  onSearchAccount: () => void;
  accountError: string | null;
  selectedAccount: SelectedAccount | null;
};

export const AccountSearch = ({
  control,
  tFormData,
  isAccountLoading,
  onSearchAccount,
  accountError,
  selectedAccount,
}: AccountSearchProps) => (
  <StyledSection>
    <StyledAccountContainer>
      <StyledInputContainer className='account-row'>
        <ControlledTextField
          name='accountId'
          control={control}
          namespace='formData'
          textFieldProps={{
            placeholder: tFormData(
              "formData.creationTemplate.accountPlaceholder",
            ),
            label: tFormData("formData.creationTemplate.accountId"),
            dataTestId: "formdata__create-template-form_accountId-input",
          }}
        />

        <StyledSearchButton
          variant='primary'
          size='s'
          isLowercase
          leftIcon={
            isAccountLoading ? (
              <CircularProgress size={16} color='inherit' />
            ) : (
              <Search width={16} height={16} color='white' />
            )
          }
          buttonText={tFormData("formData.creationTemplate.buttons.search")}
          onClick={() => {
            onSearchAccount();
          }}
        />
      </StyledInputContainer>
      {accountError && (
        <p role='alert' aria-live='polite'>
          {accountError}
        </p>
      )}
      {selectedAccount && (
        <StyledSelectedAccountTextContainer data-testid='formdata__create-template-form_selectedAccountText'>
          <Text variant='text2'>
            {tFormData("formData.creationTemplate.selectedAccount")} :
          </Text>
          <Text variant='text2' fontWeight='bold'>
            {tFormData("formData.creationTemplate.selectedAccountDetails", {
              accountNumber:
                selectedAccount.number ?? selectedAccount.accountId ?? "",
              accountName: selectedAccount.name ?? selectedAccount.label ?? "",
            })}
          </Text>
        </StyledSelectedAccountTextContainer>
      )}
    </StyledAccountContainer>
  </StyledSection>
);
